import { useMemo } from 'react'

import { useAuth } from './use-auth'
import { useQuery } from './use-query'

import { ApplicationType } from 'app/types'

type Response = {
    [key: string]: ApplicationType
}

export const useOrgApplications = () => {
    const { orgId } = useAuth()

    const $apps = useQuery<Response>(orgId ? `/c/v1/get-applications?orgId=${orgId}` : '', {
        method: 'GET'
    })

    return useMemo(
        () => ({
            orgApplications: Object.values($apps.data || {}),
            orgApplicationIds: Object.keys($apps.data || {}),
            isLoaded: !$apps.isValidating
        }),
        [$apps.data, $apps.isValidating]
    )
}
